// extracted by mini-css-extract-plugin
module.exports = {"botao":"DecorarHeroButton_botao__NiuZC","faisca":"DecorarHeroButton_faisca__mh4Rr","label":"DecorarHeroButton_label__eduK3","topo":"DecorarHeroButton_topo__CEIvX"};